import { render, staticRenderFns } from "./editSafetyForm.vue?vue&type=template&id=72c340fa&scoped=true"
import script from "./editSafetyForm.vue?vue&type=script&lang=js"
export * from "./editSafetyForm.vue?vue&type=script&lang=js"
import style0 from "./editSafetyForm.vue?vue&type=style&index=0&id=72c340fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c340fa",
  null
  
)

export default component.exports